import { FC } from "react";

import { Hamburger } from "shared/assets/icons";

import { Draggable } from "react-beautiful-dnd";
import { Checkbox } from "shared/components";
import { Spacer } from "shared/layout";
import { IFormOption } from "shared/types";
import { StyledDraggableOption, StyledDraggableOptionIcon } from "./style";

interface DraggableOptionProps {
  data: IFormOption;
  index: number;
  name: string;
  onChange: any;
  onBlur: any;
  value: any;
  triggerOnChange: any;
}
export const DraggableOption: FC<DraggableOptionProps> = ({
  data,
  index,
  name,
  onChange,
  onBlur,
  value,
  triggerOnChange,
}: DraggableOptionProps) => {
  const handleChange = (e: any) => {
    const { checked, value: checkboxValue } = e.target;

    const oldValue = value || [];

    let newList;
    if (checked) {
      newList = [...oldValue, checkboxValue];
    } else {
      newList = oldValue.filter((id: string) => id !== checkboxValue);
    }

    onChange(newList?.length === 0 ? "" : newList);
    triggerOnChange && triggerOnChange(newList);

    // Blur so validation updates
    onBlur();
  };

  return (
    <Draggable key={data.value} draggableId={data.value} index={index}>
      {provided => (
        <StyledDraggableOption
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
        >
          <Spacer size="s" spaceDirection="horizontal">
            <StyledDraggableOptionIcon as={Hamburger}></StyledDraggableOptionIcon>
            <Checkbox
              name={name}
              checked={!!value && value?.includes(data.value)}
              onChange={handleChange}
              onBlur={onBlur}
              index={index}
              {...data}
            />
          </Spacer>
        </StyledDraggableOption>
      )}
    </Draggable>
  );
};
